<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Drag And Drop {{ clientName }}</b-navbar-brand>

          <b-navbar-nav class="ml-auto"> </b-navbar-nav>
        </b-navbar>
        <b-row>
          <b-col md="6">
            <label>Type : </label>
            <model-list-select
              @input="changeOnType(2)"
              :list="typeList"
              v-model="itemType"
              option-value="TypeVal"
              option-text="TypeTxt"
              placeholder="Select Type"
            ></model-list-select>
          </b-col>
          <b-col md="6"> </b-col>

          <b-col md="6">
            <label><h5>All Coloumn</h5></label>

            <b-card class="mt-4" @dragover.prevent>
              <!-- :key="item.id + '_all_' + index" -->

              <div
                v-for="(item, index) in allItems"
                :key="item.name + '_all_' + index"
                class="item"
                :draggable="true"
                @dragstart="startDragging(item, index, 'allItems')"
                @dragend="stopDragging"
              >
                {{ parseInt(index + 1) + ". " }}{{ item.text }}
              </div>
            </b-card>
          </b-col>
          <b-col md="6">
            <label><h5>Selected Column</h5></label>
            <!-- {{selectedItems}} -->
            <b-button
              v-if="selectedItems.length > 0"
              style="font-size: 0.675rem"
              size="sm"
              variant="primary"
              @click="ClearDragExcell()"
              >Clear Excel Temp</b-button
            >
            <b-button
              style="font-size: 0.675rem"
              size="sm"
              variant="primary"
              @click="SaveClientExcell()"
              >Save Excel Temp</b-button
            >
            <b-card
              style="height: 2000px"
              class="mt-4"
              @dragover.prevent
              @drop="handleDrop('selectedItems')"
              @dragenter="dragEnter(null)"
              @dragleave="dragLeave(null)"
              @dragover.prevent="dragOver(null)"
            >
              <!-- :key="item.id + '_selected_' + index" -->
              <div
                v-for="(item, index) in selectedItems"
                :key="item.name + '_selected_' + index"
                class="item"
                :draggable="true"
                @dragstart="startDragging(item, index, 'selectedItems')"
                @dragend="stopDragging"
                @dragenter="dragEnter(index)"
                @dragleave="dragLeave(index)"
                @dragover.prevent="dragOver(index)"
                @drop="handleItemDrop(index)"
              >
                {{ parseInt(index + 1) + ". " }}{{ item.text }}
                <b-button
                  style="font-size: 0.675rem; width: 5px"
                  size="sm"
                  variant="danger"
                  @click="removeItem(index)"
                  >X</b-button
                >
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";  
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DocForm from "../allModuleForm/docLibrary.vue";
import AddMessage from "../../component/allModuleForm/addMessage.vue";
import AssignmentSummary from "../../component/common/assignmentSummary.vue";
import CommonService from "../../services/CommonService.js";
export default {
  props: {},
  data() {
    return {
      isLoading: false,
      alert: {
        content: "",
        ok: "ok",
      },
      clientName: this.$sessionsStorage.get("editClientName"),
      allItems: [],
      allItemsDSRExp: [
        {
          id: "1",
          name: "Job Type",
          text: "Job Type",
          key: "JOBTYPE",
          label: "Job Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "2",
          name: "JOB No",
          text: "JOB No",
          key: "JOBNO",
          label: "JOB No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "3",
          name: "JOB Date",
          text: "JOB Date",
          key: "JOBDATE",
          label: "JOB Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "4",
          name: "Raised From",
          text: "Raised From",
          key: "raisedFrom",
          label: "Raised From",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "5",
          name: "Raised By",
          text: "Raised By",
          key: "raisedBy",
          label: "Raised By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "6",
          name: "Client Name",
          text: "Client Name",
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "7",
          name: "Container No",
          text: "Container No",
          key: "containerNo",
          label: "Container No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "8",
          name: "Container Type",
          text: "Container Type",
          key: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "9",
          name: "TEUS",
          text: "TEUS",
          key: "TEUS_Type",
          label: "TEUS",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "10",
          name: "Container Split Remark",
          text: "Container Split Remark",
          key: "contSplitRemark",
          label: "Container Split Remark",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "11",
          name: "Shipping Line",
          text: "Shipping Line",
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "12",
          name: "Invoice No.",
          text: "Invoice No.",
          key: "billingSeries",
          label: "Invoice No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "13",
          name: "Measurement",
          text: "Measurement",
          key: "measurement",
          label: "Measurement",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "14",
          name: "Custom Seal No",
          text: "Custom Seal No",
          key: "customSealNo",
          label: "Custom Seal No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "15",
          name: "Line Seal No",
          text: "Line Seal No",
          key: "LineSealNo",
          label: "Line Seal No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "16",
          name: "Shipper Inv",
          text: "Shipper Inv",
          key: "INVNO",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "17",
          name: "Shipper Inv Date",
          text: "Shipper Inv Date",
          key: "INVDATE",
          label: "Shipper Inv Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "18",
          name: "BOE No",
          text: "BOE No",
          key: "BOENO",
          label: "BOE No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "19",
          name: "BOE Date",
          text: "BOE Date",
          key: "BOEDATE",
          label: "BOE Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "20",
          name: "GRN No.",
          text: "GRN No.",
          key: "GRNNO",
          label: "GRN No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "21",
          name: "Transportation By",
          text: "Transportation By",
          key: "tptType",
          label: "Transportation By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "22",
          name: "Vehicle No.",
          text: "Vehicle No.",
          key: "vehicleNo",
          label: "Vehicle No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "23",
          name: "Dispatch date (Departed from ICD).",
          text: "Dispatch date (Departed from ICD).",
          key: "vehicleDispatchDate",
          label: "Dispatch date (Departed from ICD).",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "24",
          name: "Stuffing / De-stuffing Date.",
          text: "Stuffing / De-stuffing Date.",
          key: "vehicleStuffingDate",
          label: "Stuffing / De-stuffing Date.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "25",
          name: "Arrival at Factory",
          text: "Arrival at Factory",
          key: "vehicleFactoryAriveDate",
          label: "Arrival at Factory",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "26",
          name: "Dispatch from Factory",
          text: "Dispatch from Factory",
          key: "vehicleFactoryDispatchDate",
          label: "Dispatch from Factory",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "27",
          name: "Arrival at Port / ICD",
          text: "Arrival at Port / ICD",
          key: "vehicleAriveAtPortDate",
          label: "Arrival at Port / ICD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "28",
          name: "Vehicle Release Date",
          text: "Vehicle Release Date",
          key: "vehicleReleaseDate",
          label: "Vehicle Release Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "29",
          name: "Container Booking No",
          text: "Container Booking No",
          key: "containerBookingNo",
          label: "Container Booking No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "30",
          name: "Freight Container Type",
          text: "Freight Container Type",
          key: "frht_activity_type",
          label: "Freight Container Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "31",
          name: "Stuffing Type",
          text: "Stuffing Type",
          key: "frht_stuffingType",
          label: "Stuffing Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "32",
          name: "Destination Delivery Mode",
          text: "Destination Delivery Mode",
          key: "frht_destination_delivery_mode",
          label: "Destination Delivery Mode",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "33",
          name: "Vessel/voyage",
          text: "Vessel/voyage",
          key: "vessel_voyage",
          label: "Vessel/voyage",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "34",
          name: "VGM Submission Date",
          text: "VGM Submission Date",
          key: "vgmSubmissionDate",
          label: "VGM Submission Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "35",
          name: "SI Submission Date",
          text: "SI Submission Date",
          key: "siSubmissionDate",
          label: "SI Submission Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "36",
          name: "Freight Term for HBL",
          text: "Freight Term for HBL",
          key: "frghtTermsHbl",
          label: "Freight Term for HBL",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "37",
          name: "Freight Term for MBL",
          text: "Freight Term for MBL",
          key: "frghtTermsMbl",
          label: "Freight Term for MBL",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "38",
          name: "B/L type",
          text: "B/L type",
          key: "blType",
          label: "B/L type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "Leo Date",
          name: "Leo Date",
          text: "Leo Date",
          key: "leoDate",
          label: "Leo Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "39",
          name: "Handover Date",
          text: "Handover Date",
          key: "handoverDate",
          label: "Handover Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "40",
          name: "TR Submission Date",
          text: "TR Submission Date",
          key: "trSubmitDateHandover",
          label: "TR Submission Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "41",
          name: "TR Submission Mode",
          text: "TR Submission Mode",
          key: "trSubmitModeHandover",
          label: "TR Submission Mode",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "42",
          name: "Train No",
          text: "Train No",
          key: "trainNo",
          label: "Train No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "43",
          name: "Wagon No",
          text: "Wagon No",
          key: "wagonNo",
          label: "Wagon No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "44",
          name: "Train Departure Date and Time",
          text: "Train Departure Date and Time",
          key: "trainDepartTime",
          label: "Train Departure Date and Time",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "45",
          name: "Train Arival Date and Time",
          text: "Train Arival Date and Time",
          key: "trainArriveDate",
          label: "Train Arival Date and Time",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "46",
          name: "Booking No",
          text: "Booking No",
          key: "validBookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "47",
          name: "MBL No.",
          text: "MBL No.",
          key: "MBL",
          label: "MBL No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "48",
          name: "HBL No",
          text: "HBL No",
          key: "HBL",
          label: "HBL No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "49",
          name: "POR",
          text: "POR",
          key: "POR",
          label: "POR",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "50",
          name: "LP",
          text: "LP",
          key: "POL",
          label: "POL",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "51",
          name: "POD",
          text: "POD",
          key: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "52",
          name: "FPOD",
          text: "FPOD",
          key: "FPOD",
          label: "FPOD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "53",
          name: "DN No.",
          text: "DN No.",
          key: "DNNo",
          label: "DN No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "54",
          name: "CN No.",
          text: "CN No.",
          key: "CNNo",
          label: "CN No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "55",
          name: "SOB",
          text: "SOB",
          key: "SOB",
          label: "SOB",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "56",
          name: "ETA Destination Estimated",
          text: "ETA Destination Estimated",
          key: "ETA_estimated",
          label: "ETA Estimated",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "57",
          name: "ETA Destination Actual",
          text: "ETA Destination Actual",
          key: "ETA_actual",
          label: "ETA Actual",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      allItemsDSRImp: [
        {
          id: "1",
          name: "Job Type",
          text: "Job Type",
          key: "JOBTYPE",
          label: "Job Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "2",
          name: "JOB No",
          text: "JOB No",
          key: "JOBNO",
          label: "JOB No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "3",
          name: "JOB Date",
          text: "JOB Date",
          key: "JOBDATE",
          label: "JOB Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "4",
          name: "Raised From",
          text: "Raised From",
          key: "raisedFrom",
          label: "Raised From",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "5",
          name: "Raised By",
          text: "Raised By",
          key: "raisedBy",
          label: "Raised By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "6",
          name: "Agent",
          text: "Agent",
          key: "agentName",
          label: "Agent",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "7",
          name: "Agent Name",
          text: "Agent Name",
          key: "agentName",
          label: "Agent Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "8",
          name: "Exporter Name",
          text: "Exporter Name",
          key: "clientName",
          label: "Exporter Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "9",
          name: "Importer Name",
          text: "Importer Name",
          key: "clientName",
          label: "Importer Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "10",
          name: "Client Name",
          text: "Client Name",
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "11",
          name: "Container No",
          text: "Container No",
          key: "containerNo",
          label: "Container No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "12",
          name: "Container Type",
          text: "Container Type",
          key: "containerType",
          label: "Container Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "13",
          name: "TEUS",
          text: "TEUS",
          key: "TEUS_Type",
          label: "TEUS",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "14",
          name: "Shipping Line",
          text: "Shipping Line",
          key: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "15",
          name: "Invoice No.",
          text: "Invoice No.",
          key: "billingSeries",
          label: "Invoice No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "16",
          name: "Measurement",
          text: "Measurement",
          key: "measurement",
          label: "Measurement",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "17",
          name: "Custom Seal No",
          text: "Custom Seal No",
          key: "customSealNo",
          label: "Custom Seal No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "18",
          name: "Line Seal No",
          text: "Line Seal No",
          key: "LineSealNo",
          label: "Line Seal No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "19",
          name: "Shipper Inv",
          text: "Shipper Inv",
          key: "INVNO",
          label: "Shipper Inv",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "20",
          name: "Shipper Inv Date",
          text: "Shipper Inv Date",
          key: "INVDATE",
          label: "Shipper Inv Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "21",
          name: "BOE No",
          text: "BOE No",
          key: "BOENO",
          label: "BOE No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "22",
          name: "BOE Date",
          text: "BOE Date",
          key: "BOEDATE",
          label: "BOE Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "23",
          name: "GRN No.",
          text: "GRN No.",
          key: "GRNNO",
          label: "GRN No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "24",
          name: "Transportation By",
          text: "Transportation By",
          key: "tptType",
          label: "Transportation By",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "25",
          name: "Vehicle No.",
          text: "Vehicle No.",
          key: "vehicleNo",
          label: "Vehicle No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "26",
          name: "Dispatch date (Departed from ICD).",
          text: "Dispatch date (Departed from ICD).",
          key: "vehicleDispatchDate",
          label: "Dispatch date (Departed from ICD).",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "27",
          name: "Stuffing / De-stuffing Date.",
          text: "Stuffing / De-stuffing Date.",
          key: "vehicleStuffingDate",
          label: "Stuffing / De-stuffing Date.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "28",
          name: "Arrival at Factory",
          text: "Arrival at Factory",
          key: "vehicleFactoryAriveDate",
          label: "Arrival at Factory",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "29",
          name: "Dispatch from Factory",
          text: "Dispatch from Factory",
          key: "vehicleFactoryDispatchDate",
          label: "Dispatch from Factory",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "30",
          name: "Arrival at Port / ICD",
          text: "Arrival at Port / ICD",
          key: "vehicleAriveAtPortDate",
          label: "Arrival at Port / ICD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "31",
          name: "Vehicle Release Date",
          text: "Vehicle Release Date",
          key: "vehicleReleaseDate",
          label: "Vehicle Release Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "32",
          name: "Container Booking No",
          text: "Container Booking No",
          key: "containerBookingNo",
          label: "Container Booking No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "33",
          name: "Freight Container Type",
          text: "Freight Container Type",
          key: "frht_activity_type",
          label: "Freight Container Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "34",
          name: "Stuffing Type",
          text: "Stuffing Type",
          key: "frht_stuffingType",
          label: "Stuffing Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "35",
          name: "Container Info",
          text: "Container Info",
          key: "frht_stuffingType",
          label: "Container Info",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "36",
          name: "SOB",
          text: "SOB",
          key: "SOB",
          label: "SOB",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "37",
          name: "Alert Received Date",
          text: "Alert Received Date",
          key: "alertReceivedDate",
          label: "Alert Received Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "38",
          name: "MBL Type.",
          text: "MBL Type.",
          key: "MBLType",
          label: "MBL Type.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "39",
          name: "MBL No.",
          text: "MBL No.",
          key: "MBL",
          label: "MBL No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "40",
          name: "MBL Date.",
          text: "MBL Date.",
          key: "MBLDate",
          label: "MBL Date.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "41",
          name: "HBL No",
          text: "HBL No",
          key: "HBL",
          label: "HBL No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "42",
          name: "HBL Date",
          text: "HBL Date",
          key: "HBLDate",
          label: "HBL Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "43",
          name: "Eta Discharge Port",
          text: "Eta Discharge Port",
          key: "etaDischargePort",
          label: "Eta Discharge Port",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "44",
          name: "Eta Final Destination",
          text: "Eta Final Destination",
          key: "etaFinalDestination",
          label: "Eta Final Destination",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "45",
          name: "Vessel/voyage",
          text: "Vessel/voyage",
          key: "vesselVoyage",
          label: "Vessel/voyage",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "46",
          name: "Vessel Arrival Date",
          text: "Vessel Arrival Date",
          key: "vesselArrivalDate",
          label: "Vessel Arrival Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "47",
          name: "Vessel ETS Date",
          text: "Vessel ETS Date",
          key: "vesselEtaDate",
          label: "Vessel ETS Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "48",
          name: "Commodity",
          text: "Commodity",
          key: "Commodity_itemName",
          label: "Commodity",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "49",
          name: "Rail Out Date",
          text: "Rail Out Date",
          key: "railOutDate",
          label: "Rail Out Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "50",
          name: "Arrival Date",
          text: "Arrival Date",
          key: "arrivalDate",
          label: "Arrival Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "51",
          name: "GateWay Igm No",
          text: "GateWay Igm No",
          key: "gateWayIgmNo",
          label: "GateWay Igm No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "52",
          name: "GateWay Igm Date",
          text: "GateWay Igm Date",
          key: "gatewayIgmDate",
          label: "GateWay Igm Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "53",
          name: "Valid Booking No",
          text: "Valid Booking No",
          key: "validBookingNo",
          label: "Valid Booking No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "54",
          name: "Assessment Date",
          text: "Assessment Date",
          key: "assessment_date",
          label: "Assessment Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "55",
          name: "Duty Challan Date",
          text: "Duty Challan Date",
          key: "duty_challan_date",
          label: "Duty Challan Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "56",
          name: "Challan AMT",
          text: "Challan AMT",
          key: "challan_amount",
          label: "Challan AMT",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "57",
          name: "Duty Challan No",
          text: "Duty Challan No",
          key: "duty_challan_no",
          label: "Duty Challan No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "58",
          name: "Release Date",
          text: "Release Date",
          key: "doReleaseDate",
          label: "Release Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "59",
          name: "Shipment Booking No",
          text: "Shipment Booking No",
          key: "validBookingNo",
          label: "Shipment Booking No",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "60",
          name: "POR",
          text: "POR",
          key: "POR",
          label: "POR",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "61",
          name: "LP",
          text: "LP",
          key: "POL",
          label: "POL",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "62",
          name: "POD",
          text: "POD",
          key: "POD",
          label: "POD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "63",
          name: "FPOD",
          text: "FPOD",
          key: "FPOD",
          label: "FPOD",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "64",
          name: "DN No.",
          text: "DN No.",
          key: "DNNo",
          label: "DN No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          id: "65",
          name: "CN No.",
          text: "CN No.",
          key: "CNNo",
          label: "CN No.",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      selectedItems:
        this.$sessionsStorage.get("editClientExcelTemplate") != undefined &&
        this.$sessionsStorage.get("editClientExcelTemplate") != null &&
        this.$sessionsStorage.get("editClientExcelTemplate") != "undefined" &&
        this.$sessionsStorage.get("editClientExcelTemplate") != "null" &&
        this.$sessionsStorage.get("editClientExcelTemplate") != ""
          ? JSON.parse(this.$sessionsStorage.get("editClientExcelTemplate"))
          : [],
      draggedItem: null,
      dropTargetIndex: null,

      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isLoading: false,
      docURL: URL_BASE_DOC,
      itemType: "DSR Export",

      typeList: [
        {
          TypeVal: "DSR Export",
          TypeTxt: "DSR Export",
        },
        {
          TypeVal: "DSR Import",
          TypeTxt: "DSR Import",
        },
      ],
    };
  },
  beforeMount() {
    // alert(this.$sessionsStorage.get("editClientExcelTemplate"));
    lastVisitPage(this.$router.history.current.fullPath);
    this.changeOnType(2);
    this.$store.dispatch("setCurrentRoute", "/drag_drop");
    if (
      this.$sessionsStorage.get("editClientId") &&
      this.$sessionsStorage.get("editClientName")
    ) {
      this.getData(2);
    }
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    DocForm,
    AddMessage,
    AssignmentSummary,
  },
  computed: {
    getListData() {
      return this.tableData.length > 0 ? this.tableData : [];
    },
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData(2);
      },
      deep: true,
    },
  },
  methods: {
    async changeOnType(id) {
      if (this.itemType == "DSR Export") {
        this.allItems = this.allItemsDSRExp;
        this.isLoading = true;
      } else if (this.itemType == "DSR Import") {
        this.allItems = this.allItemsDSRImp;
        this.isLoading = true;
      }
      await this.getData(id);

      if (id == 1) {
        this.selectedItems = [];
      }
    },
    // Method to remove an item from the selectedItems array
    removeItem(index) {
      const removedItem = this.selectedItems.splice(index, 1)[0];

      // Remove the same item from the allItems array based on a condition
      this.allItems = this.allItems.filter((item) => {
        return item.name !== removedItem.name;
      });
      this.removeSelectedItems();
    },
    removeSelectedItems() {
      this.allItems = this.allItems.filter((item) => {
        return !this.selectedItems.some((selectedItem) => {
          return selectedItem.name === item.name;
        });
      });
    },
    goBack() {
      window.history.go(-1);
    },
    async ClearDragExcell() {
      await this.changeOnType(1);
      this.selectedItems = [];
      this.selectedItems = [];
    },
    SaveClientExcell() {
      if (
        this.$sessionsStorage.get("editClientId") &&
        this.$sessionsStorage.get("editClientName")
      ) {
        let payload = {
          itemCode: "updateClientExcellTemp",
          ClientId: this.$sessionsStorage.get("editClientId"),
          ClientName: this.$sessionsStorage.get("editClientName"),
          selectedItems: this.selectedItems
            ? JSON.stringify(this.selectedItems)
            : JSON.stringify([]),
          itemType: this.itemType,
        };
        CommonService.getCheckBLDetails(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log("CLient Data=>", data);
            if (status == 200 && data) {
              if (data.FLAG) {
                this.getData(2);
              }
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Add Client Excel Error: ", error);
          });
      } else {
        this.alert.content = "Sorry Client Data Not Avilable Like Name And ID";
      }

      if (
        this.alert.content != undefined ||
        this.alert.content != null ||
        this.alert.content != ""
      ) {
        this.$refs["addPop"].open();
      }
    },
    getData(id) {
      if (
        this.$sessionsStorage.get("editClientId") &&
        this.$sessionsStorage.get("editClientName")
      ) {
        let payload = {
          itemCode: "getSingleClient",
          ClientId: this.$sessionsStorage.get("editClientId"),
          ClientName: this.$sessionsStorage.get("editClientName"),
        };
        CommonService.getCheckBLDetails(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.isLoading = false;
              if (data.CLResult) {
                this.$sessionsStorage.set("editClientId", "");
                this.$sessionsStorage.set("editClientName", "");
                this.$sessionsStorage.set("editClientExcelTemplate", "");
                this.$sessionsStorage.set("editClientId", data.CLResult.clientId);
                this.$sessionsStorage.set("editClientName", data.CLResult.clientName);

                if (this.itemType == "DSR Export") {
                  this.$sessionsStorage.set(
                    "editClientExcelTemplate",
                    data.CLResult.excel_template_json
                  );
                  this.selectedItems =
                    data.CLResult.excel_template_json != undefined &&
                    data.CLResult.excel_template_json != null &&
                    data.CLResult.excel_template_json != "undefined" &&
                    data.CLResult.excel_template_json != "null" &&
                    data.CLResult.excel_template_json != ""
                      ? JSON.parse(data.CLResult.excel_template_json)
                      : [];
                } else if (this.itemType == "DSR Import") {
                  this.$sessionsStorage.set(
                    "editClientExcelTemplate",
                    data.CLResult.DSRIMPExcelTemp
                  );
                  this.selectedItems =
                    data.CLResult.DSRIMPExcelTemp != undefined &&
                    data.CLResult.DSRIMPExcelTemp != null &&
                    data.CLResult.DSRIMPExcelTemp != "undefined" &&
                    data.CLResult.DSRIMPExcelTemp != "null" &&
                    data.CLResult.DSRIMPExcelTemp != ""
                      ? JSON.parse(data.CLResult.DSRIMPExcelTemp)
                      : [];
                }

                console.log(
                  "data.CLResult.DSRIMPExcelTemp=>",
                  data.CLResult.DSRIMPExcelTemp
                );
              }
            }
            this.isLoading = false;
            this.removeSelectedItems();
            if (id == 1) {
              this.selectedItems = [];
            }
          })
          .catch((error) => {
            console.log("Catch on Get Single Client Error: ", error);
          });
      } else {
        this.alert.content = "Sorry Client Data Not Avilable Like Name And ID";
      }
      if (
        this.alert.content != undefined ||
        this.alert.content != null ||
        this.alert.content != ""
      ) {
        // this.$refs["addPop"].open();
      }
    },
    startDragging(item, index, source) {
      this.draggedItem = { item, index, source };
    },
    stopDragging() {
      this.draggedItem = null;
      this.dropTargetIndex = null;
    },
    handleDrop(destination) {
      if (this.draggedItem) {
        const { item, index, source } = this.draggedItem;

        if (source !== destination) {
          // Check if the item is not already in selectedItems
          // const isItemInSelected = this.selectedItems.some(
          //   (selectedItem) => selectedItem.id === item.id
          // );
          const isItemInSelected = this.selectedItems.some(
            (selectedItem) => selectedItem.name === item.name
          );
          // If the item is not in selectedItems, add it
          if (!isItemInSelected) {
            this.selectedItems.push(item);
          }

          // Remove the item from the source list
          if (source === "allItems") {
            this.allItems.splice(index, 1);
          } else {
            this.selectedItems.splice(index, 1);
          }
        }

        this.draggedItem = null;
        this.dropTargetIndex = null;
      }
    },

    dragEnter(index) {
      this.dropTargetIndex = index;
    },
    dragLeave() {
      this.dropTargetIndex = null;
    },

    dragOver(index) {
      if (this.dropTargetIndex !== null && this.dropTargetIndex !== index) {
        // Splice the item from its current position and insert it at the new index
        const movedItem = this.selectedItems[this.dropTargetIndex];
        this.selectedItems.splice(this.dropTargetIndex, 1);

        setTimeout(() => {
          this.selectedItems.splice(index, 0, movedItem);
          this.dropTargetIndex = index; // Update the dropTargetIndex
        }, 200); // Adjust the delay (in milliseconds) as needed
      } else if (this.dropTargetIndex === null) {
        this.dropTargetIndex = index; // Update the dropTargetIndex when entering from outside
      }
    },

    handleItemDrop(index) {
      if (this.draggedItem) {
        const { item, source, originalIndex } = this.draggedItem;

        if (source === "selectedItems") {
          // Remove the item from the selectedItems list
          const movedItem = this.selectedItems.splice(originalIndex, 1)[0];

          // If the source and destination lists are the same, insert the item back at the original index
          if (this.dropTargetIndex !== null && this.dropTargetIndex >= 0) {
            this.selectedItems.splice(this.dropTargetIndex, 0, movedItem);
          } else {
            // If dropped outside of the selectedItems container, append to the end
            this.selectedItems.push(movedItem);
          }

          this.draggedItem = null;
          this.dropTargetIndex = null;
        }
      }
    },
  },
};
</script>

<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
/* Container styles */
.container {
  /* display: flex; */
  flex-wrap: wrap; /* Allows items to wrap to the next line if the container is not wide enough */
  border: 1px solid #ccc;
  border-radius: 8px; /* Rounded corners for the container */
  padding: 55px;
  margin: 1px;
  background-color: #fff; /* White background color */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Box shadow for a subtle lift */
}

/* Item styles */
/* .item {
  flex: 1; 
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 8px; 
  margin: 5px;
  padding: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-left-width: thick;
  -webkit-text-stroke-width: medium;
  width: max-content;
  border-bottom-width: thick;
} */

.item {
  flex: 1;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 8px;
  /* margin: 5px 0px 5px 0px;
  padding: 19px; */
  margin: 1px 0px 1px 0px;
  padding: 1px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-left-width: thick;
  -webkit-text-stroke-width: medium;
  width: max-content;
  border-bottom-width: thick;
}

.item:hover {
  background-color: #e0e0e0; /* Lighter background color on hover */
}

/* Title styles */
.item h2 {
  margin: 0;
  font-size: 18px;
  color: #333; /* Text color for the title */
}

/* Description styles */
.item p {
  margin: 8px 0;
  font-size: 14px;
  color: #666; /* Text color for the description */
}

/* Custom button styles (you can modify this as needed) */
.item button {
  background-color: #007bff; /* Button background color */
  color: #fff; /* Button text color */
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

.item button:hover {
  background-color: #0056b3; /* Button background color on hover */
}
</style>



// WEBPACK FOOTER //
// drag_drop.vue?0f5cc49e